<template>
  <div class="pop_box">
    <div class="mask" v-on:click="hidePop"></div>
    <div class="pop_main">
      <div class="pop_cont">
        <div class="img">
          <img :src=" 'http://moderncap.pengjisoft.com/'+ pop_data.logo" alt>
        </div>
        <h2 v-if="this.$i18n.locale !== 'zh-CN' ">{{ pop_data.name_en }}</h2>
        <p v-if="this.$i18n.locale !== 'zh-CN' ">{{ pop_data.brief_en }}</p>
        <h2 v-if="this.$i18n.locale === 'zh-CN' ">{{ pop_data.name_zh }}</h2>
        <p v-if="this.$i18n.locale === 'zh-CN' ">{{ pop_data.brief_zh }}</p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    pop_data: {}
  },
  methods: {
    hidePop: function() {
      this.$emit("hidePop");
    }
  }
};
</script>

<style lang="less" scoped>
.pop_box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 9;
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    opacity: 0.8;
    position: absolute;
    z-index: 9;
  }
  .pop_main {
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .pop_cont {
      text-align: center;
      color: #ffffff;
      z-index: 99;
      padding: 30px;
      .img {
        width: 133px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        // border-radius: 50%;
        overflow: hidden;
        padding: 5px;
        background: #ffffff;
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
      img {
        width: 100%;
      }
      h2 {
        font-size: 28px;
        font-weight: 400;
        margin-top: 20px;
        margin-bottom: 30px;
      }
      p {
        font-size: 16px;
        line-height: 32px;
        max-width: 400px;
      }
    }
  }
}
</style>

